import * as api from "./api";
export const CONTACT_US_GET_ACCOUNT_HOLDER_REQUEST = "CONTACT_US_GET_ACCOUNT_HOLDER_REQUEST";
export const CONTACT_US_GET_ACCOUNT_HOLDER_SUCCESS = "CONTACT_US_GET_ACCOUNT_HOLDER_SUCCESS";
export const CONTACT_US_GET_ACCOUNT_HOLDER_FAILURE = "CONTACT_US_GET_ACCOUNT_HOLDER_FAILURE";
export const getOfficeAccountHolderRequest = () => {
    return {
        type: CONTACT_US_GET_ACCOUNT_HOLDER_REQUEST,
    };
};
export const getOfficeAccountHolderFailure = (response) => {
    return {
        type: CONTACT_US_GET_ACCOUNT_HOLDER_FAILURE,
        payload: response
    };
};
export const getOfficeAccountHolderSuccess = (response) => {
    return {
        type: CONTACT_US_GET_ACCOUNT_HOLDER_SUCCESS,
        payload: response
    };
};
export const getOfficeAccountHolder = (officeId) => {
    return (dispatch) => {
        dispatch(getOfficeAccountHolderRequest());
        api.getOfficeAccountManager(dispatch, officeId)
            .then((accountHolder) => {
            dispatch(getOfficeAccountHolderSuccess(accountHolder));
        }, (error) => dispatch(getOfficeAccountHolderFailure(error)));
    };
};
